module.exports = __webpack_public_path__ + "img/bgd9.99151351.svg";